export const PricePlaneFirstData=[
    {
        header:'DELUXE',
        price:'9',
        chat:'10Hr',
        limit:'500MB',
        support:'No',
        domain:'1',
        fees:'No',
    },
    {
        header:'ECONOMY',
        price:'29 ',
        chat:'100hr',
        limit:'50GB',
        support:'Yes',
        domain:'2',
        fees:'No',
    },
    {
        header:'ULTIMATE',
        price:'39',
        chat:'Unlimited',
        limit:'Unlimi',
        support:'Yes',
        domain:'Unlimited',
        fees:'No',
    },

]

export const PricePlaneSecondData=[
    {
        header:'Basic',
        discription:'Individual',
        price:'8',
    },
    {
        header:'Standard',
        discription:'Small Business',
        price:'20',
    },
    {
        header:'Premium',
        discription:'Large Company',
        price:'40',
    },

]

export const PricePlaneThirdData=[
    {
        header:'DELUXE',
        price:'9',
        chat:'10Hr',
        limit:'500MB',
        support:'No',
        domain:'1',
        fees:'No',
    },
    {
        header:'ECONOMY',
        price:'29 ',
        chat:'100hr',
        limit:'50GB',
        support:'Yes',
        domain:'2',
        fees:'No',
    },
    {
        header:'ULTIMATE',
        price:'39',
        chat:'Unlimited',
        limit:'Unlimi',
        support:'Yes',
        domain:'Unlimited',
        fees:'No',
    },

]